<template>
    <div class="mt-0 flex flex-col p-5 md:p-10">
        <div class="border-b border-gray-400 flex items-center md:pb-8 pb-3 px-8">
            <div>
                <svg class="h-4 md:h-6 my-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 396.99 73.59"><g id="Calque_2" data-name="Calque 2"><g id="Calque_1-2" data-name="Calque 1"><path d="M113.79,0H98.21A1.2,1.2,0,0,0,97,1.18V72.29a1.2,1.2,0,0,0,1.21,1.18h15.58A1.2,1.2,0,0,0,115,72.29V1.18A1.2,1.2,0,0,0,113.79,0"/><path d="M60.57,0H1.2A1.19,1.19,0,0,0,0,1.18V72.29a1.19,1.19,0,0,0,1.2,1.18H16.79A1.2,1.2,0,0,0,18,72.29V16.48a1.19,1.19,0,0,1,1.2-1.18H52.79c9.44,0,12.12,7.24,12.12,11.9V72.29a1.2,1.2,0,0,0,1.21,1.18H81.7a1.2,1.2,0,0,0,1.21-1.18V21.85c0-4.16-.5-10.15-5.87-15.41C71.42.94,66.3,0,60.57,0"/><path d="M49.66,28.32H33.3a1.2,1.2,0,0,0-1.22,1.18V72.3a1.2,1.2,0,0,0,1.22,1.17H49.66a1.19,1.19,0,0,0,1.21-1.17V29.5a1.2,1.2,0,0,0-1.21-1.18"/><path d="M202.8,48.58c-4.3,14.61-18.05,25-34.56,25a36.66,36.66,0,1,1-.1-73.31C188.48.38,200,15.37,202.8,25.67h-15a22,22,0,0,0-19.76-12.88c-13.75,0-22.63,11.55-22.63,24.05,0,12.89,9.26,24.25,22.72,24.25,12.6,0,18.33-9.93,19.67-12.51Z"/><path d="M216.83,72.26H201.37L230,1.62h12.51l28,70.64H254.92l-5.16-13.84H221.89Zm18.81-53.84-10,28.64H246Z"/><path d="M277.64,1.62H299c11,0,17.28,1.72,21.1,4.49,5.82,4.2,9,11.36,9,19.18a23.08,23.08,0,0,1-3.82,13.18c-3,4.48-7.06,6.49-11.64,7.63l15.75,26.16H314.49l-19-32.84h2.77c4.68,0,9.74-.29,12.69-2.58a13.21,13.21,0,0,0,4.49-10.31,12.12,12.12,0,0,0-5.25-10.21c-2.58-1.62-6-2.2-10-2.2h-8.31V72.26H277.64Z"/><path d="M337.88,1.62h39.61v12.5H352.1v16H377V42.67H352.1V59.75h25.39V72.26H337.88Z"/><path d="M390.68,1.26a6.49,6.49,0,0,1,3.12.82,5.83,5.83,0,0,1,2.34,2.33,6.36,6.36,0,0,1,0,6.32,6,6,0,0,1-2.34,2.33,6.29,6.29,0,0,1-3.14.84,6.36,6.36,0,0,1-3.15-.84,6.07,6.07,0,0,1-2.33-2.33,6.3,6.3,0,0,1,0-6.32,5.83,5.83,0,0,1,2.34-2.33A6.49,6.49,0,0,1,390.68,1.26Zm0,1.24a5.21,5.21,0,0,0-2.5.65A4.79,4.79,0,0,0,386.3,5a5.25,5.25,0,0,0-.68,2.56,5.1,5.1,0,0,0,.67,2.53A4.83,4.83,0,0,0,388.16,12a5.14,5.14,0,0,0,2.53.68,5.07,5.07,0,0,0,2.52-.68,4.85,4.85,0,0,0,1.88-1.88,5.07,5.07,0,0,0,0-5.09,4.79,4.79,0,0,0-1.89-1.87A5.24,5.24,0,0,0,390.69,2.5ZM387.83,11V4.26h3.5a2.66,2.66,0,0,1,1.05.27,1.71,1.71,0,0,1,.63.65,1.81,1.81,0,0,1,.25,1,1.81,1.81,0,0,1-.47,1.24,2.23,2.23,0,0,1-1.34.64,1.46,1.46,0,0,1,.47.25,3.76,3.76,0,0,1,.46.51c.05.07.21.34.49.82l.79,1.35H392l-.56-1.09a4.51,4.51,0,0,0-.94-1.38,1.5,1.5,0,0,0-.94-.28h-.35V11Zm1.36-3.81h.55a6.77,6.77,0,0,0,1.46-.09.87.87,0,0,0,.45-.32.84.84,0,0,0-.45-1.32,6,6,0,0,0-1.46-.1h-.55Z"/></g></g></svg>
            </div>

            <div class="ml-auto text-sm flex flex-col items-end">
                <span class="text-gray-600">Magasin</span>
                <span class="md:text-xl">Paris Sébastopol</span>

                <button @click.prevent="logout" class="hover:underline text-blue-500">Se déconnecter</button>
            </div>
        </div>

        <AffSteps
            key="Di8eop3"
            v-if="step != 'insurance' && step != 'enrolled'"
            :step="step" 
            v-on:select-step="selectStep($event)"
        />

        <InsuranceForm
            key="qei6Ed3"
            class="my-20"
            v-if="step == 'insurance'"
            v-on:select-type="selectType($event)"
        />

        <ProductForm 
            key="43dheA"
            v-else-if="step == 'product'"
            v-model="product"
            :type="type"
            v-on:go-back="type = null; product = null; step = 'insurance'"
            v-on:confirm-type="confirmType($event)"
        />

        <ImeiForm
            v-if="step == 'imei'"
            :product="product"
            :type="type"
            v-on:validate-imei="validateImei($event)"
        />

        <CustomerForm
            key="Deo4edl"
            v-if="step == 'customer'"
            :product="product"
            :customer-previous="customer"
            :type="type"
            v-on:validate-customer="validateCustomer($event)"
        />

        <PaymentForm
            key="9je3ek"
            v-else-if="step == 'payment'"
            :product="product"
            :customer="customer"
            :type="type"
            v-on:enrolled="enrolled"
        />

        <EnrolledBlock
            :product="product"
            v-else-if="step == 'enrolled'"
            :customer="customer"
            :type="type"
            v-on:restart="restart"
        />

        </div>
    </div>
</template>

<script>
import InsuranceForm from '@/components/enrolment/InsuranceForm'
import ProductForm from '@/components/enrolment/ProductForm'
import ImeiForm from '@/components/enrolment/ImeiForm'
import CustomerForm from '@/components/enrolment/CustomerForm'
import PaymentForm from '@/components/enrolment/PaymentForm'
import EnrolledBlock from '@/components/enrolment/EnrolledBlock'

import AffSteps from '@/components/enrolment/Steps'

export default {
    components: { InsuranceForm, ProductForm, CustomerForm, PaymentForm, AffSteps, ImeiForm, EnrolledBlock },
    data: function () {
        return {
            step: 'insurance',
            type: null,
            globalType: null,
            product: null,
            customer: null
        }
    },
    methods: {
        selectType: function (type) {
            this.type = type;
            this.globalType = type;
            this.step = 'product';
            window.scrollTo(0,0);
        },
        confirmType: function (payload) {
            this.type = payload.type;
            this.product = payload.product;

            this.step = 'imei';
            window.scrollTo(0,0);
        },
        logout: function () {
            window.sessionStorage.removeItem('shop_username')
            window.sessionStorage.removeItem('shop_access_token')

            this.$router.push('/shop/login');
        },
        selectStep: function (step) {
            if(step == 'product' && (this.step == 'imei' || this.step == 'customer' || this.step == 'payment')) {
                this.step = step;
                this.type = this.globalType;
                window.scrollTo(0,0);
            } else if(step == 'imei' && (this.step == 'customer' || this.step == 'payment')) {
                this.step = step;
                window.scrollTo(0,0);
            } else if(step == 'imei' && (this.step == 'customer' || this.step == 'payment')) {
                this.step = step;
                window.scrollTo(0,0);
            }
        },
        validateImei: function (imei) {
            this.product.imei = imei;
            this.step = 'customer';
        },
        validateCustomer: function (customer) {
            this.customer = customer;
            this.step = "payment";
        },
        enrolled: function () {
            this.step = 'enrolled'
        },
        restart: function () {
            this.customer = null;
            this.step = 'insurance';
            this.type = null;
            this.globalType = null;
            this.product = null;
        }
    }
}
</script>